import React from 'react';
import type { TFunction } from 'i18next';

export interface StepperProps { t: TFunction; }

export function Stepper({ t }: StepperProps): React.ReactElement {
  const steps = [
    { n: "1", label: t("common.steps.selectedPlan"), state: "done" },
    { n: "2", label: t("common.steps.addPayroll"), state: "active" },
    { n: "3", label: t("common.steps.checkout"), state: "future" },
  ];
  return (
    <div className="inline-flex flex-wrap items-center gap-8">
      {steps.map((s, i) => (
        <React.Fragment key={i}>
          {i > 0 && <div className="h-px bg-stroke" style={{ width: 50 }} />}
          <div className="flex items-center gap-2.5">
            <div
              className={"flex items-center justify-center rounded-full font-extrabold " + (s.state === "future" ? "border border-stroke text-helper" : "text-white") + " " + (s.state === "active" ? "bg-ink" : s.state === "done" ? "bg-brand" : "bg-white")}
              style={{ width: 30, height: 30, fontSize: 13 }}
            >{s.n}</div>
            <span className={s.state === "active" ? "text-ink font-bold" : "text-helper"} style={{ fontSize: s.state === "active" ? 15 : 14 }}>{s.label}</span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}
